import React from 'react';
import styled from 'styled-components';
import { device } from "../device";
import PropTypes from 'prop-types';

const ColorBlock = styled.div`
    display: flex;
`;
const Color = styled.div`
    flex: 0 0 48px;
    max-width: 48px;
    height: 88px;
    width: 48px;
    margin-right: 8px;
    @media ${device.sm} {
        flex: 0 0 88px;
        max-width: 88px;
        width: 88px;
    }
`;
const Number = styled.div`
    font-size: 24px;
    font-weight: 500;
    line-height: 1.33;
`;
const Hex = styled.div`
    color: var(--midle-gray4);
    font-size: 14px;
`;

const ColorItem = (props) => {
    
    const number = props.number;
    const hex = props.hex;
    return (
        <ColorBlock>
            <Color style={{background: props.background}} />
            <div>
                {number && <Number>{number}</Number>}
                {hex && <Hex>{hex}</Hex>}
            </div>
        </ColorBlock>
    );
};

ColorItem.propTypes = {
    background: PropTypes.string,
    number: PropTypes.string,
    hex: PropTypes.string
};

export default ColorItem;